export enum ATFBadgeType {
  IMMEDIATE_RESERVATION = 'IMMEDIATE_RESERVATION',
  OFFLINE_POINT = 'OFFLINE_POINT',
}
